const popoverShadowIndex = 8;
const confirmModalShadowIndex = 24;

export const INCLUDED_SHADOW_INDEXES = [
  popoverShadowIndex,
  confirmModalShadowIndex,
];
